/* ==========================================================================
   WSPR site shell – assets/wspr-site.js (all pages, defer)
   - Header theme: dark/light glass depending on the [data-wspr-theme] section
     under the header (home page); other pages default to light.
   - Adaptive logo: hidden while a theme drawer or modal covers it.
   - Shop mega menu: opens on hover (with a short grace delay) or click,
     category hover/focus switches the subcategories and the photo.
   - Mobile menu drawer.
   ========================================================================== */
(function () {
  'use strict';
  var d = document;
  var w = window;
  var root = d.documentElement;

  function init() {
    var hd = d.querySelector('[data-wspr-hd]');
    if (!hd) return;
    var shopBtn = hd.querySelector('[data-wspr-shop]');
    var mega = hd.querySelector('[data-wspr-mega]');
    var burger = hd.querySelector('[data-wspr-burger]');
    var scrim = d.querySelector('[data-wspr-scrim]');
    var blend = d.querySelector('.wspr-logo-blend');
    var mark = d.querySelector('.wspr-logo-mark');
    var isHome = d.body.classList.contains('wspr-home');
    var themed = [].slice.call(d.querySelectorAll('[data-wspr-theme]'));
    var desktop = w.matchMedia('(min-width: 1040px)');
    var wide = w.matchMedia('(min-width: 990px)');
    var hoverCapable = w.matchMedia('(hover: hover)');
    var closeTimer = null;
    var openedAt = 0;
    var ready = false;
    setTimeout(function () { ready = true; }, 350);
    var queued = false;

    /* ---------- header theme ----------
       1) a section marked [data-wspr-theme] under the header wins (home page, footer);
       2) otherwise sample the page colour just below the header (3 points, majority). */
    function bgLum(el) {
      while (el && el !== d.documentElement) {
        var cs = w.getComputedStyle(el);
        var m = cs.backgroundColor.match(/rgba?\(([^)]+)\)/);
        if (m) {
          var p = m[1].split(',').map(parseFloat);
          if (p.length < 4 || p[3] > 0.5) return (0.2126 * p[0] + 0.7152 * p[1] + 0.0722 * p[2]) / 255;
        }
        el = el.parentElement;
      }
      return 1;
    }
    function sampleTheme() {
      var r0 = hd.getBoundingClientRect();
      var y = Math.min(w.innerHeight - 2, r0.top + (wide.matches ? 76 : 64) + 6);
      var dark = 0, votes = 0;
      [0.15, 0.5, 0.85].forEach(function (fx) {
        var el = d.elementFromPoint(w.innerWidth * fx, y);
        if (!el || hd.contains(el) || el === scrim) return;
        votes++;
        if (bgLum(el) < 0.45) dark++;
      });
      if (!votes) return null;
      return dark * 2 > votes ? 'dark' : 'light';
    }
    function updateTheme() {
      if (hd.classList.contains('is-open')) return; // keep the tint while a menu is open
      var theme = null;
      var mid = hd.getBoundingClientRect().top + 38;
      for (var i = 0; i < themed.length; i++) {
        var r = themed[i].getBoundingClientRect();
        if (r.top <= mid && r.bottom > mid) { theme = themed[i].getAttribute('data-wspr-theme'); break; }
      }
      if (!theme) theme = isHome ? 'dark' : (ready ? sampleTheme() : null) || hd.getAttribute('data-theme') || 'light';
      if (hd.getAttribute('data-theme') !== theme) hd.setAttribute('data-theme', theme);
    }

    /* ---------- logo hidden under drawers / modals ---------- */
    function checkCovered() {
      if (!blend) return;
      var r = hd.getBoundingClientRect();
      var x = w.innerWidth / 2;
      var y = r.top + (wide.matches ? 38 : 32);
      var el = d.elementFromPoint(x, y);
      var covered = !!el && !hd.contains(el) && el !== blend && el !== mark && !(blend.contains(el) || (mark && mark.contains(el)));
      blend.classList.toggle('is-covered', covered);
      if (mark) mark.classList.toggle('is-covered', covered);
    }

    /* floating WhatsApp button: same light/dark glass logic as the header */
    var floatBtn = d.querySelector('[data-wspr-float]');
    function updateFloat() {
      if (!floatBtn || !ready) return;
      var r = floatBtn.getBoundingClientRect();
      if (!r.width) return;
      var x = r.left + r.width / 2, y = r.top + r.height / 2;
      var stack = d.elementsFromPoint ? d.elementsFromPoint(x, y) : [];
      var el = null;
      for (var i = 0; i < stack.length; i++) {
        if (!floatBtn.contains(stack[i]) && stack[i] !== blend && stack[i] !== mark) { el = stack[i]; break; }
      }
      if (!el) return;
      var th = null;
      for (var k = 0; k < themed.length; k++) {
        var tr = themed[k].getBoundingClientRect();
        if (tr.top <= y && tr.bottom > y) { th = themed[k].getAttribute('data-wspr-theme'); break; }
      }
      if (!th) th = bgLum(el) < 0.45 ? 'dark' : 'light';
      if (floatBtn.getAttribute('data-theme') !== th) floatBtn.setAttribute('data-theme', th);
    }

    function frame() {
      queued = false;
      updateTheme();
      updateFloat();
      checkCovered();
    }
    function queue() {
      if (queued) return;
      queued = true;
      w.requestAnimationFrame(frame);
    }

    /* ---------- open states ---------- */
    function setOpenFlags() {
      var mOpen = hd.classList.contains('is-mega');
      var dOpen = hd.classList.contains('is-drawer');
      hd.classList.toggle('is-open', mOpen || dOpen);
      if (scrim) scrim.classList.toggle('is-on', mOpen);
      root.classList.toggle('wspr-menu-open', mOpen || dOpen);
      root.classList.toggle('wspr-lock', dOpen);
      queue();
    }

    function loadImages() {
      if (!mega || mega._loaded) return;
      mega._loaded = true;
      [].forEach.call(mega.querySelectorAll('img[data-src]'), function (img) {
        img.src = img.getAttribute('data-src');
        img.removeAttribute('data-src');
      });
    }

    function openMega() {
      if (!mega) return;
      clearTimeout(closeTimer);
      loadImages();
      if (!hd.classList.contains('is-mega')) openedAt = Date.now();
      hd.classList.add('is-mega');
      shopBtn.setAttribute('aria-expanded', 'true');
      setOpenFlags();
    }
    function closeMega() {
      clearTimeout(closeTimer);
      hd.classList.remove('is-mega');
      if (shopBtn) shopBtn.setAttribute('aria-expanded', 'false');
      setOpenFlags();
    }
    function closeSoon() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, 220);
    }

    function setActive(i) {
      ['data-wspr-cat', 'data-wspr-pane', 'data-wspr-feat'].forEach(function (attr) {
        [].forEach.call(mega.querySelectorAll('[' + attr + ']'), function (el) {
          el.classList.toggle('is-active', el.getAttribute(attr) === String(i));
        });
      });
    }

    if (shopBtn && mega) {
      shopBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (hd.classList.contains('is-mega')) { if (Date.now() - openedAt > 450) closeMega(); } else openMega();
      });
      shopBtn.addEventListener('mouseenter', function () { if (hoverCapable.matches && desktop.matches) openMega(); });
      shopBtn.addEventListener('mouseleave', function () { if (hoverCapable.matches) closeSoon(); });
      mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      mega.addEventListener('mouseleave', function () { if (hoverCapable.matches) closeSoon(); });
      [].forEach.call(mega.querySelectorAll('[data-wspr-cat]'), function (a) {
        var i = a.getAttribute('data-wspr-cat');
        a.addEventListener('mouseenter', function () { setActive(i); });
        a.addEventListener('focus', function () { setActive(i); });
      });
      // keyboard: open on ArrowDown, leave the panel with Tab past the end
      shopBtn.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); openMega(); var f = mega.querySelector('[data-wspr-cat]'); if (f) f.focus(); }
      });
      mega.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || (!mega.contains(e.relatedTarget) && e.relatedTarget !== shopBtn)) closeMega();
      });
    }

    if (scrim) scrim.addEventListener('click', closeMega);

    // "Whisper to us" in the mega menu: say which category the customer was browsing
    var waMega = hd.querySelector('[data-wspr-wa-mega]');
    if (waMega && mega) {
      var waBase = waMega.getAttribute('href');
      waMega.addEventListener('click', function () {
        var cur = mega.querySelector('.wspr-mega__cat.is-active span');
        if (!cur) return;
        var cat = cur.textContent.trim();
        waMega.setAttribute('href', waBase.replace('Shop%20menu', 'Shop%20menu%20%28browsing%20' + encodeURIComponent(cat).replace(/%20/g, '%20') + '%29'));
      });
    }

    if (burger) {
      burger.addEventListener('click', function () {
        var open = !hd.classList.contains('is-drawer');
        hd.classList.toggle('is-drawer', open);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        setOpenFlags();
      });
    }

    // theme search / cart triggers inside our menus: close our menus first
    [].forEach.call(hd.querySelectorAll('xo-modal-trigger'), function (t) {
      t.addEventListener('click', function () {
        if (hd.classList.contains('is-drawer')) {
          hd.classList.remove('is-drawer');
          if (burger) burger.setAttribute('aria-expanded', 'false');
        }
        closeMega();
        setTimeout(queue, 60);
        setTimeout(queue, 450);
      });
    });

    // anchor links in the drawer (same page) close it
    [].forEach.call(hd.querySelectorAll('.wspr-drawer a[href*="#"], .wspr-hd__nav a[href*="#"]'), function (a) {
      a.addEventListener('click', function () {
        hd.classList.remove('is-drawer');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        setOpenFlags();
      });
    });

    d.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (hd.classList.contains('is-mega')) { closeMega(); if (shopBtn) shopBtn.focus(); }
      if (hd.classList.contains('is-drawer')) { hd.classList.remove('is-drawer'); if (burger) { burger.setAttribute('aria-expanded', 'false'); burger.focus(); } setOpenFlags(); }
    });

    desktop.addEventListener && desktop.addEventListener('change', function () {
      hd.classList.remove('is-drawer', 'is-mega');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      if (shopBtn) shopBtn.setAttribute('aria-expanded', 'false');
      setOpenFlags();
    });

    w.addEventListener('scroll', queue, { passive: true });
    w.addEventListener('resize', queue, { passive: true });
    w.addEventListener('load', function () { queue(); setTimeout(frame, 700); setTimeout(frame, 1600); });
    // first paint can still be covered by the theme's page-load overlay: sample again shortly after
    setTimeout(frame, 400);
    d.addEventListener('click', function () { setTimeout(queue, 60); setTimeout(queue, 450); }, true);
    setInterval(function () { if (!d.hidden) checkCovered(); }, 700);
    frame();
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Copy & save freedom (29 Sep): nothing on the site may block the native context menu,
   copying or text selection — designers rely on saving pictures and copying specs. Any script
   (theme, app embed, pixel) that calls preventDefault on these events is neutralised here:
   capture-phase listeners on window run first and stop the event reaching them. */
(function () {
  ['contextmenu', 'copy', 'cut', 'selectstart'].forEach(function (type) {
    window.addEventListener(type, function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('input, textarea, [contenteditable="true"]')) return;
      e.stopImmediatePropagation();
    }, true);
  });
  ['oncontextmenu', 'oncopy', 'onselectstart', 'ondragstart'].forEach(function (p) {
    try { document[p] = null; document.body && (document.body[p] = null); } catch (err) {}
  });
})();
